// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

// Which user turn an assistant answer belongs to. Kept out of the component so
// it can be unit-tested without rendering React (same reason as
// `formatMessageTime`), and because this is the step the SPA rewrite lost: the
// `question` field of POST /feedback comes from here.

import { Message } from "@/components/chat/types"

/**
 * Text of the user turn that produced `messages[index]`.
 *
 * Walks backwards from `index - 1` and returns the first message with
 * `role === "user"`. In a multi-turn thread that yields the question for THAT
 * turn rather than the first of the conversation — the correct attribution when
 * one session accumulates several rated answers.
 *
 * Returns "" when there is no preceding user turn (a restored transcript that
 * starts on `assistant`, or the first message in the thread). The empty string
 * still travels in the request body: the backend needs it to tell "there was no
 * question" apart from "the client stopped sending one".
 *
 * @param messages - the ordered thread, exactly as rendered.
 * @param index - position of the assistant answer being rated.
 */
export function precedingUserQuestion(messages: Message[], index: number): string {
  for (let i = Math.min(index, messages.length) - 1; i >= 0; i--) {
    if (messages[i].role === "user") return messages[i].content
  }
  return ""
}
